<template>
  <div class="self-media">
    <div class="header">
      <div class="logo">
        <a-icon type="twitter" v-if="mediaData.mediaType == 'twitter'" />
        <a-icon type="facebook" v-if="mediaData.mediaType == 'facebook'" />
        <a-icon type="weibo" v-if="mediaData.mediaType == 'weibo'" />
        <!-- <img width="100%" height="100%" :src="mediaData.thumbnail" alt="" /> -->
      </div>
      <a class="title" :href="mediaData.url" target="_blank" v-html="mediaData.name"></a>
      <div class="time">{{ mediaData.publishTime }}</div>
    </div>
    <div class="content">
      <div class="paragraph" v-html="mediaData.tweet"></div>
      <div class="photo">
        <img
          v-for="item in JSON.parse(mediaData.photosStr)"
          :key="item"
          width="292"
          height="200"
          :src="item"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['mediaData']
}
</script>

<style lang="less" scoped>
.self-media {
  .header {
    display: flex;
    align-items: center;
    .logo {
      width: 40px;
      height: 40px;
      background: #1da1f2;
      margin-right: 13px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 22px;
        color: #fff;
      }
      img {
        border-radius: 50%;
      }
    }
    .title {
      font-size: 20px;
      color: #1f2e4c;
      margin-right: 21px;
    }
    .time {
      font-size: 14px;
      color: #999999;
    }
  }
  .content {
    padding-left: 53px;
    .paragraph {
      line-height: 24px;
      color: #333333;
    }
    .photo {
      margin-top: 20px;
      img {
        margin: 0 10px 10px 0;
      }
    }
  }
}
</style>
